import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClockSvgComponent } from './clock-svg.component';

@NgModule({
  declarations: [
    ClockSvgComponent
  ],
  imports: [
    CommonModule
  ], exports: [
    ClockSvgComponent
  ]
})
export class ClockSvgModule { }